/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';
import {
  func, shape, bool,
} from 'prop-types';

import { toBase64 } from '../../utils/base64Parser';
import Banner from '../../components/Banner';
import { getDealBannerFromStorage } from '../../../../actions/influencer';

const DealBannerContainer = memo((props) => {
  const {
    storage,
    influencer,
    handleBannerChange,
    bannerData,
    influencerPage,
    disabled,
  } = props;

  useEffect(() => {
    if (influencer.id && influencerPage.deal.bannerImageUrl) {
      props.getDealBannerFromStorage(influencer.id, influencerPage.deal.bannerImageUrl);
    }
  }, [influencerPage.deal.bannerImageUrl]);

  const onBannerChange = async (e) => {
    const { files } = e.target;
    const file = files[0];
    const base64String = await toBase64(file);

    handleBannerChange({
      url: base64String,
      name: file.name,
    });
  };

  return (
    <Banner
      onBannerChange={onBannerChange}
      bannerUrl={storage.dealBannerUrl}
      alt={influencer.name}
      bannerData={bannerData}
      classNameSuffix="deal"
      id="upload-deal-banner"
      disabled={disabled}
    />
  );
});

DealBannerContainer.propTypes = {
  influencer: shape().isRequired,
  storage: shape().isRequired,
  bannerData: shape().isRequired,
  influencerPage: shape().isRequired,
  handleBannerChange: func.isRequired,
  getDealBannerFromStorage: func.isRequired,
  disabled: bool.isRequired,
};

const mapStateToProps = state => ({
  influencer: state.influencer.item,
  storage: state.influencer.storage,
  bannerData: state.influencer.dealBannerData,
  influencerPage: state.influencer.item.page,
});

const actionCreators = {
  getDealBannerFromStorage,
};

export default connect(mapStateToProps, actionCreators)(DealBannerContainer);
